import { Big } from 'big.js';
import { bigToString, parseBig, QuoteService } from 'quote-domain-core';
import { singleton } from 'tsyringe';

@singleton()
export class QuoteServiceSetupService {
    public calculate(quoteService: QuoteService, referential: any): void {
        const factorVt = this.calculateFactorVt(quoteService, referential);
        const factorFreeMonth = this.calculateFreeMonth(quoteService);
        Object.assign(quoteService, { factorVt, factorFreeMonth });
    }

    public calculateFactorVt(quoteService: QuoteService, referential: any): string {
        if (quoteService.contractInfoInputs.isVtContract) {
            return bigToString(referential.contractVtChecked.value);
        }
        return bigToString(referential.contractVtUnchecked.value);
    }

    public calculateFreeMonth(quoteService: QuoteService): string {
        if (quoteService.contractInfoInputs.offeredMonthNbr && quoteService.contractInfoInputs.contractDuration) {
            const bigOfferedMonth = parseBig(quoteService.contractInfoInputs.offeredMonthNbr);
            const bigContractDuration = parseBig(quoteService.contractInfoInputs.contractDuration);
            if (bigOfferedMonth.gt(new Big(0)) && bigContractDuration.gt(new Big(0))) {
                return bigToString(new Big(1).add(bigOfferedMonth.div(bigContractDuration)));
            }
        }
        return '1';
    }

    public calculateLogisticsPrice(quoteService: QuoteService, referential: any): void {
        const visitingFrequencyInput = quoteService.contractInfoInputs.changeOverFrequency;
        const distanceInKmInput = +quoteService.contractInfoInputs.averageDistance;
        const numberOfSitesInput = +quoteService.contractInfoInputs.siteNbr;
        if (numberOfSitesInput > 0) {
            const visitingFrequencyInputValue = referential.frequencies.filter((freq: { frequency: any; }) => freq.frequency === visitingFrequencyInput)[0];
            const coefficientVisitingFrequency = visitingFrequencyInputValue.monthlyVisit;
            const marginCoefficient = referential.marginCoefficient.value;
            const vehicleType = referential.vehicle.filter((vehicle: { type: any; }) => vehicle.type === 'lightVehicle')[0];
            const pricePerKm = vehicleType.kmCost;
            const pricePerStop = vehicleType.stopCost;
            if (coefficientVisitingFrequency === 1 && numberOfSitesInput === 1 && distanceInKmInput <= 30) {
                Object.assign(quoteService, { totalLogisticsPrice: bigToString(new Big('0')) });
            } else {
                const distancePriceSupp = (2 * Math.max((distanceInKmInput - 30), 0) * pricePerKm) * coefficientVisitingFrequency * numberOfSitesInput;
                const visitingPriceSupp = pricePerStop * (coefficientVisitingFrequency * (numberOfSitesInput - 1));
                const result = marginCoefficient * (distancePriceSupp + visitingPriceSupp);
                Object.assign(quoteService, { totalLogisticsPrice: bigToString(new Big(result)) });
            }
        }
    }
}
